module.exports = __webpack_public_path__ + "img/revolut-dark.56592937.png";